/* eslint-disable no-console */
import { assertInInjectionContext, inject, InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

const currentCorrelationId = new InjectionToken('CORRELATION_ID', {
	providedIn: 'root',
	factory: () => {
		console.log('Injecting current correlation id');
		const id = sessionStorage.getItem(environment.sessionCorrelationKey);
		if (!id) {
			console.warn('No correlation id found in session storage, generating a new one');
			const newId = crypto.randomUUID();
			sessionStorage.setItem(environment.sessionCorrelationKey, newId);
			console.log('Generated new correlation id:', newId);
			return newId;
		}
		console.log('Found existing correlation id:', id);
		return id;
	},
});

export function injectCorrelationId() {
	assertInInjectionContext(injectCorrelationId);
	return inject(currentCorrelationId);
}
